














































































































































































import { AppConstants, Interfaces, Models, Utils, apiService } from "@/core/Export";
import store from "@/store";
import DxList from 'devextreme-vue/list';
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
    components: { DxList }
})
export default class TeamLeaderPage extends Vue {
    selectedEmployeesIds: Array<any>;
    activeTab: string;
    hour: string;
    minutes: string;
    seconds: string;
    today: string;
    day: string;
    isInPunchInProcess: boolean;
    missingEventMultipleReportDto: Models.MissingEventMulitpleReportEntry;
    missingEventsInit: Array<any>;
    isShowPartialInPortal: boolean;
    isShowFillTekenInPortal: boolean;
    permissionsEventWithoutRemark: boolean;
    permissions: any;
    dateMask: string;
    isSaveButtonDisabeld: boolean;
    attendMulitpleReportDto: Models.AttendMulitpleReportEntryDto;
    attendMulitpleReportSpecialEvents: Array<any>;

    constructor() {
        super();
        this.isInPunchInProcess = false;
        this.activeTab = "reportImidiatlly";
        this.selectedEmployeesIds = [];
        this.missingEventsInit = [];
        this.missingEventMultipleReportDto = new Models.MissingEventMulitpleReportEntry();
        this.isShowPartialInPortal = false;
        this.isShowFillTekenInPortal = false;
        this.permissions = AppConstants.Permissions;
        this.dateMask = "DD/MM/YYYY";
        this.isSaveButtonDisabeld = false;
        this.attendMulitpleReportDto = new Models.AttendMulitpleReportEntryDto();
        this.attendMulitpleReportSpecialEvents = [];
        this.hour = null;
        this.minutes = null;
        this.seconds = null;
        this.today = this.appEnv.formatDate(new Date().toString());
    }

    created() {
        this.appEnv.screenTitle = this.$t("pages.teamTeader.title");
        this.day = this.$t("dayOfWeek." + new Date().getDay().toString()) as string;
        this.updateClock();
        setInterval(this.updateClock, 1000);
    }


    onListInitialized(e) {
        e.component.option("selectAllText", this.$t("selectAll"));
    }

    updateClock() {
        let today = new Date();
        this.hour = today.getHours().toString();
        if (this.hour.length == 1) {
            this.hour = `0${this.hour}`;
        }
        this.minutes = today.getMinutes().toString();
        if (this.minutes.length == 1) {
            this.minutes = `0${this.minutes}`;
        }
        this.seconds = today.getSeconds().toString();
        if (this.seconds.length == 1) {
            this.seconds = `0${this.seconds}`;
        }
    }

    @Watch("activeTab")
    onTabChanged() {
        if (this.activeTab == "reportMissingEvent") {
            this.loadMissingEventMultipleReport();
        } else if (this.activeTab == "reportManual") {
            this.attendMulitpleReportDto = new Models.AttendMulitpleReportEntryDto();
            this.attendMulitpleReportSpecialEvents = [];
        }
    }

    onSelectionChanged(e) {
        let addedItems = e.addedItems;
        addedItems.forEach(item => {
            this.selectedEmployeesIds.push(item.id);
        });

        let removedItems = e.removedItems;
        removedItems.forEach(item => {
            let index = this.selectedEmployeesIds.indexOf(item.id);
            this.selectedEmployeesIds.splice(index, 1);
        });
    }

    onPunchInOut(isExit: boolean = false) {
        if (this.isInPunchInProcess) return;

        this.isInPunchInProcess = true;
        let timeZone = new Date().getTimezoneOffset() / -60;
        let dto = new Models.PortalTeamLeaderEmployeesPunchInOutDto(timeZone, isExit, this.selectedEmployeesIds);
        let urlPath = "Portal/teamLeader/employees/punchinout";
        this.appEnv.isBusy = true;
        apiService
            .post(urlPath, dto)
            .then(res => {
                let result = res as Interfaces.ICallResult;
                if (result && result.isSuccess) {
                    Utils.Notification.notifyPositive(this.$t("msgs.save").toString(), "thumb_up");
                } else {
                    this.appEnv.showErrorDialog(result.msgs.msgs);
                }
            })
            .catch(err => {
            })
            .finally(() => {
                this.appEnv.isBusy = false;
                this.isInPunchInProcess = false;
            })
    }

    loadMissingEventMultipleReport() {
        this.appEnv.isBusy = true;
        apiService
            .getSingle(AppConstants.Entites.MissingEventMulitpleReport, {
                id: -1
            })
            .then(res => {
                let call = res.calls[0] as Interfaces.iServiceCall;
                if (call && call.isSuccess) {
                    this.missingEventMultipleReportDto = call.callResult.data;
                    this.missingEventsInit = this.missingEventMultipleReportDto.missingEvents;
                    this.onFilterMissingEvents();
                } else {
                    this.appEnv.showErrorDialog(call.msgs.msgs);
                }
            })
            .catch(err => {
            })
            .finally(() => {
                this.appEnv.isBusy = false;
            })
    }

    onMissingEventOptionChanged(value) {
        if (
            (value != 3 && this.missingEventMultipleReportDto.fromTimeText) ||
            this.missingEventMultipleReportDto.toTimeText
        ) {
            this.missingEventMultipleReportDto.fromTimeText = null;
            this.missingEventMultipleReportDto.toTimeText = null;
        }

        if (value != 4) {
            //this.missingEventMultipleReportDto.isDeleteFiles = false;
        }
        if (value == 4) {
            //this.missingEventMultipleReportDto.isDeleteFiles = true;
        }
    }

    onMissingEventIdChanged(e) {
        let missingEvent = this.missingEventMultipleReportDto.missingEvents.find((q) => q.id === e);
        if (missingEvent) {
            this.isShowPartialInPortal = missingEvent.addField2; //isShowPartialInPortal
            this.isShowFillTekenInPortal = missingEvent.addField3; //isShowFillTekenInPortal
        } else {
            this.isShowPartialInPortal = false;
            this.isShowFillTekenInPortal = false;
        }

        if (!this.isShowFillTekenInPortal || !this.isShowPartialInPortal) {
            this.missingEventMultipleReportDto.missingEventOption = this.missingEventOptions[0].value;
        }

        if (!this.isShowPartialInPortal) {
            this.missingEventMultipleReportDto.fromTimeText = null;
            this.missingEventMultipleReportDto.toTimeText = null;
        }
        if (this.permissions.EventWithoutRemark) {
            if (missingEvent.addField5) {
                this.permissionsEventWithoutRemark = true;
            }
            else {
                this.permissionsEventWithoutRemark = false;
            }
        }
    }

    onFilterMissingEvents() {
        let allowedMissingEventsIds = this.appEnv.UserInfo.availableMissingEventsIds as Array<any>;
        if (allowedMissingEventsIds.length > 0) {
            let missingEvents = [];

            let emptyMissingEvent = this.missingEventMultipleReportDto.missingEvents.find(
                (q) => q.code == "EMPTY"
            );
            if (emptyMissingEvent) missingEvents.push(emptyMissingEvent);

            allowedMissingEventsIds.forEach((allowedMissingEvent) => {
                let missingEvent = this.missingEventMultipleReportDto.missingEvents.find(
                    (q) => q.id == allowedMissingEvent
                );
                if (missingEvent) missingEvents.push(missingEvent);
            });
            this.missingEventsInit = missingEvents;
            this.missingEventMultipleReportDto.missingEvents = missingEvents;
        }
    }

    onFiterMissingEventModel(val, update, abort) {
        update(() => {
            const needle = val.toLowerCase();
            this.missingEventMultipleReportDto.missingEvents = this.missingEventsInit.filter((v) =>
                v.name.includes(needle)
            );
        });
    }

    onSaveMissingEventMultipleReport() {
        this.isSaveButtonDisabeld = true;
        this.appEnv.isBusy = true;
        this.missingEventMultipleReportDto.employeeIds = this.selectedEmployeesIds;
        apiService
            .saveSingle(AppConstants.Entites.MissingEventMulitpleReport, this.missingEventMultipleReportDto)
            .then(res => {
                let call = res.calls[0] as Interfaces.iServiceCall;
                if (call && call.isSuccess) {
                    Utils.Notification.notifyPositive(this.$t("msgs.save").toString(), "thumb_up");
                } else {
                    this.appEnv.showErrorDialog(call.msgs.msgs);
                }
            })
            .catch(err => {
            })
            .finally(() => {
                this.appEnv.isBusy = false;
                this.isSaveButtonDisabeld = false;
            })
    }

    @Watch("attendMulitpleReportDto.fromDate")
    @Watch("attendMulitpleReportDto.toDate")
    onFromDateToDateChanged() {
        if (this.attendMulitpleReportDto.fromDate && this.attendMulitpleReportDto.toDate)
            this.getAttendMultipleReport();
    }

    getAttendMultipleReport() {
        this.attendMulitpleReportDto.employeeIds = this.selectedEmployeesIds;
        this.appEnv.isBusy = true;
        apiService.getAttendMultipleReport(this.attendMulitpleReportDto.fromDate, this.attendMulitpleReportDto.toDate, this.attendMulitpleReportDto.employeeIds)
            .then(res => {
                let call = res.calls[0] as Interfaces.iServiceCall;
                if (call && call.isSuccess) {
                    this.attendMulitpleReportDto.lines = call.callResult.data;
                    this.attendMulitpleReportDto.canEnterSpecialDates = call.callResult.canEnterSpecialDates;
                    this.attendMulitpleReportSpecialEvents = call.callResult.specialEvents;

                    this.attendMulitpleReportDto.lines = [];
                    let line = new Models.AttendMulitpleReportEntryLineDto();
                    line.toSave = true;
                    line.toDelete = false;
                    this.attendMulitpleReportDto.lines.push(line);

                } else {
                    this.appEnv.showErrorDialog(call.msgs.msgs);
                }
            })
            .finally(() => {
                this.appEnv.isBusy = false;
            })
    }

    saveAttendMultipleReport() {
        this.appEnv.isBusy = true;
        this.isSaveButtonDisabeld = true;
        apiService.saveAttendMultipleReport(this.attendMulitpleReportDto.fromDate, this.attendMulitpleReportDto.toDate, this.attendMulitpleReportDto.employeeIds, this.attendMulitpleReportDto.lines, true, AppConstants.SourceCode.Portal)
            .then(res => {
                let call = res.calls[0] as Interfaces.iServiceCall;
                if (call && call.isSuccess) {
                    Utils.Notification.notifyPositive(this.$t("msgs.save").toString(), "thumb_up");
                } else {
                    this.appEnv.showErrorDialog(call.msgs.msgs);
                }
            })
            .finally(() => {
                this.appEnv.isBusy = false;
                this.isSaveButtonDisabeld = false;
            })
    }

    onEntryTimeTextChanged(e, line) {
        line.entryTimeText = Models.AppUtils.formatTime(e.target.value);
    }

    onExitTimeTextChanged(e, line) {
        line.exitTimeText = Models.AppUtils.formatTime(e.target.value);
    }

    onFromTimeChanged(e) {
        this.missingEventMultipleReportDto.fromTimeText = Models.AppUtils.formatTime(e.target.value);
    }

    onToTimeChanged(e) {
        this.missingEventMultipleReportDto.toTimeText = Models.AppUtils.formatTime(e.target.value);
    }

    validateTime(value) {
        if (this.missingEventMultipleReportDto.missingEventOption == 3) {
            if (!value) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    validateReplaceMissingEvent(value) {
        if (this.missingEventMultipleReportDto.missingEventOption == 6) {
            if (!value) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    validateComment(value) {
        if (this.permissionsEventWithoutRemark) {
            return !value ? false : true;
        }
        if (this.appEnv.isAllowed(this.permissions.EventWithoutRemark)) {
            return true;
        } else {
            return !value ? false : true;
        }
    }

    get missingEventOptions() {
        let baseMissingEvents = [];
        baseMissingEvents.push({ label: this.$t("missingEventOptions.fullDay"), value: 1 });
        if (this.isShowFillTekenInPortal) {
            baseMissingEvents.push({
                label: this.$t("missingEventOptions.fillTeken"),
                value: 2,
            });
        }
        if (this.isShowPartialInPortal) {
            baseMissingEvents.push({
                label: this.$t("missingEventOptions.paritalAttend"),
                value: 3,
            });
        }
        if (this.isAllowUploadAttachment) {
            baseMissingEvents.push({
                label: this.$t("missingEventOptions.uploadFiles"),
                value: 5,
            });
        }
        baseMissingEvents.push({
            label: this.$t("missingEventOptions.replaceFullDay"),
            value: 6,
        });
        baseMissingEvents.push({
            label: this.$t("missingEventOptions.deletionAttend"),
            value: 4,
        });
        return baseMissingEvents;
    }

    get isAllowUploadAttachment() {
        if (this.appEnv.isAllowed(AppConstants.Permissions.PortalUploadAttachment)) {
            return true;
        }
        return false;
    }

    get employeesList() {
        return store.getters.employeesList;
    }

    get selectedYear() {
        return store.getters.selectedYear;
    }

    get selectedMonth() {
        return store.getters.selectedMonth;
    }

    get currentEmployee() {
        return store.getters.currentEmployee;
    }

    set currentEmployee(value) {
        store.commit(AppConstants.StoreMutations.UpdateCurrentEmployee, value);
    }

    get appEnv() {
        return store.getters.appEnv;
    }
}
